import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const [email, setEmail] = useState("admin@shop.com");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (admin) return <Navigate to="/admin/dashboard" replace />;

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white border border-black/10 p-10">
        <div className="text-xs uppercase tracking-ultra text-neutral-500">Admin</div>
        <h1 className="mt-2 text-4xl font-black tracking-tighter">Sign in</h1>
        <form onSubmit={handle} className="mt-8 space-y-6">
          <div>
            <label className="block text-[10px] uppercase tracking-ultra text-neutral-500 mb-2">
              Email
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border-b border-black bg-transparent py-2 text-sm outline-none focus:border-b-2"
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-ultra text-neutral-500 mb-2">
              Password
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border-b border-black bg-transparent py-2 text-sm outline-none focus:border-b-2"
              data-testid="admin-login-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-black text-white py-4 text-xs uppercase tracking-ultra font-bold hover:bg-neutral-800 transition-colors disabled:opacity-50"
            data-testid="admin-login-submit"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
        <div className="mt-6 text-[10px] uppercase tracking-ultra text-neutral-500">
          Default: admin@shop.com / admin123
        </div>
      </div>
    </div>
  );
}
